import { Divider } from 'primereact/divider';
import { Fieldset } from 'primereact/fieldset';
import { useDispatch, useSelector } from "react-redux";
import { Field, Form } from 'react-final-form';

import moment from 'moment';
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { AppDispatch } from '../../../../store';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chip } from 'primereact/chip';
import { Tag } from 'primereact/tag';
import { compareResumes, downloadResumeForAdmin, retrieveResume, updateResume } from '../ResumeAction';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';
import { MultiSelect } from 'primereact/multiselect';
import { classNames } from 'primereact/utils';
import { LOOKUPS_KEY } from '../../../../constants/localStorageKeys';
import { CategoryEnum } from '../../Lookup/enums';
import { Chips } from 'primereact/chips';
import DatatableItem from '../../../../constants/helpers/DatatableItem';
import LinkButton from '../../../../constants/helpers/LinkButton';
import { Message } from 'primereact/message';
import { Badge } from 'primereact/badge';
import { Resume } from '../interface';
import { Dialog } from 'primereact/dialog';
import VersionCompareTable from './CompareVersion/VersionCompareTable';
import { useLookupOptions } from '../../../../constants/helpers/useLookupOptions';
import FieldChange from '../../../../utils/FieldChange';

interface ResumeViewProps {
  editMode?: boolean
}

const ResumeView = (props: ResumeViewProps) => {
  const { editMode } = props
  const { resumeId } = useParams<{ resumeId: string }>()
  const history = useHistory()

  const dispatch = useDispatch<AppDispatch>()
  const { resume, compareResults } = useSelector((state: any) => state.resume)

  // primefaces custom input component
  const [version, setVersion] = useState<number>(0)
  const [currentSalary, setCurrentSalary] = useState<number>(0)
  const [expectedSalary, setExpectedSalary] = useState<number>(0)
  const [yearsOfExp, setYearsOfExp] = useState<number>(0)
  const [dob, setDob] = useState<Date>(new Date())
  const [availStartDate, setAvailStartDate] = useState<Date>(new Date())

  // datatable editables
  const [education, setEducation] = useState([] as any)
  const [workExperience, setWorkExperience] = useState([] as any)
  const [socialLink, setSocialLink] = useState([] as any)
  const [professionalCertificate, setProfessionalCertificate] = useState([] as any)

  // lookups
  const {
    countryList, languageList, qualificationList,
  } = useLookupOptions()

  // compare dialog
  const [compareDialog, setCompareDialog] = useState(false)

  useEffect(() => {
    init()
  }, [])

  const init = () => {
    // retrieve resume details
    dispatch(retrieveResume(Number(resumeId))).unwrap()
    .then((resume: any) => {
      // set form fields
      setVersion(resume.version)
      setCurrentSalary(resume.currentSalary || undefined)
      setExpectedSalary(resume.expectedSalary || undefined)
      setYearsOfExp(resume.totalYearsOfExperiences || undefined)
      setDob(new Date(resume.dateOfBirth || undefined))
      setAvailStartDate(new Date(resume.availStartDate || undefined))
      setEducation(resume.education)
      setWorkExperience(resume.workExperience)
      setProfessionalCertificate(resume.professionalCertificate)
      setSocialLink(resume.socialLink)
    });
  }

  const handleDownloadResume = (e: any) => {
    dispatch(downloadResumeForAdmin(resume.id)).then((link: any) => {
      // Create a new link
      const linkElement = document.createElement('a');
      linkElement.href = link.payload;

      // Set the download name
      linkElement.setAttribute('download', resume.fileName);

      // Programmatically click the link to trigger the download
      document.body.appendChild(linkElement);
      linkElement.click();

      // Remove the link from the body
      document.body.removeChild(linkElement);
    })
    e.preventDefault()
  }

  const validate = (data: any) => {
    let errors = {} as any

    if (!data.fullName) {
      errors.fullName = "Full Name is required."
    }
    if (!data.contactNumber) {
      errors.contactNumber = "Contact Number is required."
    }
    if (!data.email) {
      errors.email = "E-Mail is required."
    }
    else if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(data.email) !== true) {
      errors.email = "Please enter a valid E-Mail."
    }
    if (!data.gender) {
      errors.gender = "Gender is required."
    }
    if (!data.dateOfBirth) {
      errors.dateOfBirth = "Date of Birth is required."
    }
    if (!data.nationality) {
      errors.nationality = "Nationality is required."
    }
    if (!data.residence) {
      errors.residence = "Residence is required."
    }
    if (!data.country) {
      errors.country = "Country is required."
    }
    if (!data.highestQualification) {
      errors.highestQualification = "Qualification is required."
    }
    if (!data.currentEmploymentStatus) {
      errors.currentEmploymentStatus = "Current Employment Status is required."
    }
    if (!data.availStartDate) {
      errors.availStartDate = "Available Start Date is required."
    }
    if (!data.currentSalary && data.currentSalary !== 0) {
      errors.currentSalary = "Current Salary is required."
    }
    if (!data.expectedSalary && data.expectedSalary !== 0) {
      errors.expectedSalary = "Expected Salary is required."
    }
    if (!data.totalYearsOfExperiences && data.totalYearsOfExperiences !== 0) {
      errors.totalYearsOfExperiences = "Years of Experience is required."
    }

    if (!data.languageProficiency || data.languageProficiency.length === 0) {
      errors.languageProficiency = "Language Proficiency are required."
    }
    if (!data.skills || data.skills.length === 0) {
      errors.skills = "Please define at least one skill."
    }
    if (!data.education || data.education.length === 0) {
      errors.skills = "Please provide your education."
    }
    if (!data.version) {
      errors.version = "Version is required."
    }
    console.log('errors', errors)
    return errors;
  }

  const onSubmit = async (values: any) => {
    dispatch(updateResume({
      // initial values
      ...resume, 
      // updated values
      ...values,
      // updated tables
      education,
      workExperience,
      professionalCertificate,
      socialLink,
    })).unwrap()
    .then(() => {
      // redirect to view page
      history.push("/resumes/" + resumeId)
    });
  }

  const isFormFieldValid = (meta: any) => !!(meta.touched && meta.error)

  const getFormErrorMessage = (meta: any) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>
  }

  const setVersionAsActive = (selectedResume: Resume) => {
    
  }

  const compareVersionWithActive = (selectedResume: Resume) => {
    // loop through resume.versionHistory to get ID of active version
    const activeVersion = resume.versionHistory.find((version: Resume) => version.active)
    dispatch(compareResumes({ resumeId1: selectedResume.id, resumeId2: activeVersion.id }))

    // open compare dialog
    setCompareDialog(true)
  }

  return (
    <>
      <div className="formgrid grid align-self-center mx-2 my-3">
        <div className="field col-12">
          {!editMode ?
            <LinkButton to={"/resumes/" + resumeId + "/update"} icon="eye" label="Edit" />
            :
            <LinkButton to={"/resumes/" + resumeId} icon="arrow-left" label="View" />
          }
          <Button className="p-button-primary ml-2" icon="pi pi-download" label="Download Resume File" onClick={handleDownloadResume} />
        </div>
        <div className="col-12">
          {resume ?
            <Card>
              {resume.status === 'FILLED_IN' && <Message text={"This resume is fully filled-in."} severity="success" className="w-full justify-content-start mb-3" />}
              {resume.status === 'PARTIALLY_FILLED' && <Message text={"This resume is partially filled-in, hence matching results might not be accurate."} severity="warn" className="w-full justify-content-start mb-3" />}
              {resume.status === 'MISSING_MANDATORY_FIELDS' && <Message text={"This resume has missing mandatory fields thus won't be used during matching."} severity="error" className="w-full justify-content-start mb-3" />}

              {!resume.active && <Message text={"There are new version of this resume hence modifications done on this version will not take effect."} severity="warn" className="w-full justify-content-start mb-3" />}

              <Form
                mutators={{
                  // expect (field, value) args from the mutator
                  setValue: ([field, value], state, { changeValue }) => {
                    changeValue(state, field, () => value)
                  }
                }}
                onSubmit={onSubmit}
                initialValues={resume}
                validate={validate}
                render={({ handleSubmit, form, submitting, pristine, values }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="flex formgrid grid">
                      <div className="col-12 mb-3">
                        <Fieldset legend="Personal Details">
                          <div className="grid">
                            <div className="field col-6 p-mb-3">
                              <strong>Full Name: </strong>
                              {editMode ? (
                                <Field name="fullName">
                                  {({ input, meta }) => (
                                    <div>
                                      <InputText {...input} type="text" className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.fullName
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Contact Number: </strong>
                              {editMode ? (
                                <Field name="contactNumber">
                                  {({ input, meta }) => (
                                    <div>
                                      <InputText {...input} type="text" className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.contactNumber || '-'
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>E-Mail: </strong>
                              {editMode ? (
                                <Field name="email">
                                  {({ input, meta }) => (
                                    <div>
                                      <InputText {...input} type="email" className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.email || '-'
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Gender: </strong>
                              {editMode ? (
                                <Field name="gender">
                                  {({ input, meta }) => (
                                    <div>
                                      <Dropdown {...input} options={["Male", "Female"]} className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.gender || '-'
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Date of Birth: </strong>
                              {editMode ? (
                                <Field name="dateOfBirth">
                                  {({ input, meta }) => (
                                    <div>
                                      <Calendar
                                        {...input}
                                        value={dob}
                                        onChange={(e) => {
                                          setDob(e.value || new Date());
                                          input.onChange(e.value);
                                        }}
                                        dateFormat="yy-mm-dd"
                                        yearRange="1950:2025"
                                        className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })}
                                      />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.dob?.toString().substring(0, 10) || '-'
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Nationality: </strong>
                              {editMode ? (
                                <Field name="nationality">
                                  {({ input, meta }) => (
                                    <div>
                                      <InputText {...input} type="text" className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.nationality || '-'
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Residence: </strong>
                              {editMode ? (
                                <Field name="residence">
                                  {({ input, meta }) => (
                                    <div>
                                      <Dropdown {...input} className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} options={countryList} />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.residence || '-'
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Country: </strong>
                              {editMode ? (
                                <Field name="country">
                                  {({ input, meta }) => (
                                    <div>
                                      <Dropdown {...input} className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} options={countryList} />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.country || '-'
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Highest Qualification: </strong>
                              {editMode ? (
                                <Field name="highestQualification">
                                  {({ input, meta }) => (
                                    <div>
                                      <Dropdown {...input} className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} options={qualificationList} />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.highestQualification || '-'
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Current Employment Status: </strong>
                              {editMode ? (
                                <Field name="currentEmploymentStatus">
                                  {({ input, meta }) => (
                                    <div>
                                      <Dropdown {...input} className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} options={["Full-Time Employment", "Part-Time Employment", "Self Employed", "Unemployed", "Student"]} />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.currentEmploymentStatus || '-'
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Availability: </strong>
                              {editMode ? (
                                <Field name="availStartDate">
                                  {({ input, meta }) => (
                                    <div>
                                      <Calendar
                                        {...input}
                                        value={availStartDate}
                                        onChange={(e) => {
                                          setAvailStartDate(e.value || new Date());
                                          input.onChange(e.value);
                                        }}
                                        dateFormat="yy-mm-dd"
                                        yearRange={`${new Date().getFullYear()}:2030`}
                                        className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })}
                                      />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.availStartDate?.toString().substring(0, 10) || '-'
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Current Salary: </strong> S$
                              {editMode ? (
                                <Field name="currentSalary">
                                  {({ input, meta }) => (
                                    <div>
                                      <InputNumber
                                        {...input}
                                        value={currentSalary}
                                        prefix="$"
                                        mode="currency"
                                        currency="SGD"
                                        min={0}
                                        className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })}
                                        onChange={(e) => FieldChange(setCurrentSalary, input, e.value || 0)}
                                        onValueChange={(e) => FieldChange(setCurrentSalary, input, e.value || 0)}
                                      />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.currentSalary || '-'
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Expected Salary: </strong> S$
                              {editMode ? (
                                <Field name="expectedSalary">
                                  {({ input, meta }) => (
                                    <div>
                                      <InputNumber
                                        {...input}
                                        value={expectedSalary}
                                        prefix="$"
                                        mode="currency"
                                        currency="SGD"
                                        min={0}
                                        className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })}
                                        onChange={(e) => FieldChange(setExpectedSalary, input, e.value || 0)}
                                        onValueChange={(e) => FieldChange(setExpectedSalary, input, e.value || 0)}
                                      />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.expectedSalary || '-'
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Years of Experience: </strong>
                              {editMode ? (
                                <Field name="totalYearsOfExperiences">
                                  {({ input, meta }) => (
                                    <div>
                                      <InputNumber
                                        {...input}
                                        value={yearsOfExp}
                                        suffix=" year(s)"
                                        min={0}
                                        max={100}
                                        className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })}
                                        onChange={(e) => FieldChange(setYearsOfExp, input, e.value || 0)}
                                        onValueChange={(e) => FieldChange(setYearsOfExp, input, e.value || 0)}
                                      />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.totalYearsOfExperiences || '-'
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Skills: </strong>
                              {editMode ? (
                                <Field name="skills">
                                  {({ input, meta }) => (
                                    <div>
                                      <Chips {...input} className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} separator="," />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                <div className="mt-2" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                  {resume.skills?.map((skill: string, index: number) => (
                                    <span className="p-chip ml-1 mb-1">{skill}</span>
                                  ))}
                                </div>
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Language Proficiency: </strong>
                              {editMode ? (
                                <Field name="languageProficiency">
                                  {({ input, meta }) => (
                                    <div>
                                      <MultiSelect {...input} filter className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} options={languageList} showClear placeholder="Select Language(s)" />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.languageProficiency?.map((language: string, index: number) => (
                                  <span className="p-chip mx-1 mb-1">{language}</span>
                                ))
                              )}
                            </div>
                            <div className="field col-6 p-mb-3">
                              <strong>Version: </strong>
                              {editMode ? (
                                <Field name="version">
                                  {({ input, meta }) => (
                                    <div>
                                      <InputNumber
                                        {...input}
                                        value={version}
                                        min={0}
                                        className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })}
                                        onChange={(e) => FieldChange(setVersion, input, e.value || 0)}
                                        onValueChange={(e) => FieldChange(setVersion, input, e.value || 0)}
                                      />
                                      {getFormErrorMessage(meta)}
                                    </div>
                                  )}
                                </Field>
                              ) : (
                                resume.version
                              )}
                            </div>
                          </div>
                        </Fieldset>
                      </div>
                      <div className="col-12 mb-3">
                        <Fieldset legend="Education">
                          <div className="field m-0">
                            {editMode ? (
                              <DatatableItem
                                data={education}
                                setData={setEducation}
                                fields={{
                                  courseTitle: 'Course Title',
                                  educationLevel: 'Education Level',
                                  institutionName: 'Institution Name',
                                  numberOfYears: 'No. of Years'
                                }}
                                className="inputfield w-full"
                              />
                            ) : (
                              <DataTable value={resume.education} responsiveLayout="scroll">
                                <Column field="courseTitle" header="Course Title"></Column>
                                <Column field="educationLevel" header="Education Level"></Column>
                                <Column field="institutionName" header="Institution Name"></Column>
                                <Column field="numberOfYears" header="Number of Years"></Column>
                              </DataTable>
                            )}
                          </div>
                        </Fieldset>
                      </div>
                      
                      <div className="col-12 mb-3">
                        <Fieldset legend="Work Experiences">
                          <div className="field m-0">
                            {editMode ? (
                              <DatatableItem
                                data={workExperience}
                                setData={setWorkExperience}
                                fields={{
                                  companyName: 'Company',
                                  numberOfYears: 'No. of Years',
                                  title: 'Title',
                                  roleSummary: 'Summary',
                                  skills: 'Skills'
                                }}
                                className="inputfield w-full"
                              />
                            ) : (
                              <DataTable value={resume.workExperience} responsiveLayout="scroll">
                                <Column field="companyName" header="Company Name"></Column>
                                <Column field="numberOfYears" header="Number of Years"></Column>
                                <Column field="title" header="Title"></Column>
                                <Column field="roleSummary" header="Role Summary"></Column>
                                <Column
                                  field="skills"
                                  header="Skills"
                                  body={(rowData) => (
                                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                      {rowData.skills.map((skill: string, index: number) => (
                                        <span key={index} className="p-chip mx-1 mb-1">{skill}</span>
                                      ))}
                                    </div>
                                  )}
                                ></Column>
                              </DataTable>
                            )}
                          </div>
                        </Fieldset>
                      </div>

                      <div className="col-12 mb-3">
                        <Fieldset legend="Professional Certificates">
                          <div className="field m-0">
                            {editMode ? (
                              <DatatableItem
                                data={professionalCertificate}
                                setData={setProfessionalCertificate}
                                fields={{
                                  title: 'Certificate',
                                  issuerName: 'Issuer Name',
                                  dateIssued: 'Date Issued'
                                }}
                                className="inputfield w-full"
                              />
                            ) : (
                              <DataTable value={resume.professionalCertificate} responsiveLayout="scroll">
                                <Column field="title" header="Title"></Column>
                                <Column field="issuerName" header="Issuer Name"></Column>
                                <Column field="dateIssued" header="Date Issued"></Column>
                              </DataTable>
                            )}
                          </div>
                        </Fieldset>
                      </div>

                      <div className="col-12 mb-3">
                        <Fieldset legend="Social Links">
                          <div className="field m-0">
                            {editMode ? (
                              <DatatableItem
                                data={socialLink}
                                setData={setSocialLink}
                                fields={{
                                  name: 'Platform',
                                  link: 'Link'
                                }}
                                className="inputfield w-full"
                              />
                            ) : (
                              <DataTable value={resume.socialLink} responsiveLayout="scroll">
                                <Column field="name" header="Name"></Column>
                                <Column field="link" header="Link"></Column>
                              </DataTable>
                            )}
                          </div>
                        </Fieldset>
                      </div>
                      <div className="col-12 mb-3">
                        {editMode && (
                          <Button label="Save" type="submit" icon="pi pi-check" />
                        )}
                      </div>

                      {!editMode && (
                        <div className="col-12 mb-3">
                          <Fieldset legend="Version History">
                            <div className="field m-0">
                              <DataTable value={resume.versionHistory} responsiveLayout="scroll">
                                <Column field="version" header="Version" body={(rowData) => (
                                  <>
                                    {rowData.version}
                                    {rowData.active && <Badge value="Active" severity="success" className="ml-2"></Badge>}
                                    {rowData.version === resume.version && <Badge value="Current" className="ml-2"></Badge>}
                                  </>
                                )}></Column>
                                <Column field="status" header="Status"></Column>
                                <Column field="createdDate" header="Created Date"></Column>
                                <Column field="createdBy" header="Created By" body={(rowData) => (
                                  <>
                                    {rowData.createdBy === 'Unknown' ? <em>User Uploaded</em> : rowData.createdBy}
                                  </>
                                )}></Column>
                                <Column
                                  header="Action"
                                  body={(rowData) => (
                                      <>
                                        <LinkButton to={"/resumes/" + rowData.id} icon="pi pi-eye" iconOnly={true} tooltip="View this Version" />
                                        {/* <Button icon="pi pi-star" className="ml-2" onClick={() => setVersionAsActive(rowData)} tooltip="Mark this version as Active" disabled={rowData.active} /> */}
                                        <Button icon="pi pi-arrow-right-arrow-left" className="ml-2" onClick={() => compareVersionWithActive(rowData)} tooltip="Compare this version with Active" disabled={rowData.active} />
                                      </>
                                  )}
                                ></Column>
                              </DataTable>
                            </div>
                          </Fieldset>
                        </div>
                      )}
                    </div>
                  </form>
                )}
              />
            </Card>
            :
            <></>}
        </div>
      </div >
      <Dialog header="Compare Version" 
        visible={compareDialog} 
        style={{ width: '80vw' }} 
        onHide={() => { if (!compareDialog) return; setCompareDialog(false); }}>
        <p className="m-0">
          <VersionCompareTable data={compareResults} />
        </p>
      </Dialog>
    </>
  )
}

export default ResumeView